import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  useGetParentCompanyInfoList,
  useGoToCompany,
} from "../api/CompaniesApi";
import PageHeader from "../shared-components/PageHeader";
import Pagination from "../shared-components/Pagination";
import Table from "./Table";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import { AddCompanyButton } from "./AddCompanyButton";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import SearchBar from "./SearchBar";
import { CompanyListInputApi } from "../api/Companies";

// TODO: `Express check` Column is a relation between the company and the blueprint
// wait to get the full company information for the listing
const Companies = () => {
  const {
    isLoading: loadingCompanies,
    data: companyData,
    mutate: getCompanyFetchList,
    error: errorGetCompanies,
  } = useGetParentCompanyInfoList();

  const { companies } = usePermissionValidator();
  const { goToCompany, goToSubCompany } = useGoToCompany();
  const pageSize = 25;
  const [total, setTotal] = useState(0);
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [searchCompanyName, setSearch] = useState(
    searchParams.get("search") || ""
  );
  const [page, setPage] = useState(1);

  const tableHeader = ["Company", "Checks"];

  useEffect(() => {
    setSearch(searchParams.get("search")?.trim().toLowerCase() || "");

    if (searchParams.get("page")) {
      setPage(Number(searchParams.get("page")));
    }
  }, [searchParams]);

  useEffect(() => {
    const fetchAttr: CompanyListInputApi = {
      size: pageSize,
      page: page,
    };

    if (searchCompanyName) {
      fetchAttr.search = searchCompanyName;
    }
    getCompanyFetchList(fetchAttr);
  }, [getCompanyFetchList, searchCompanyName, page]);

  useEffect(() => {
    setTotal(companyData?.total ?? 1);
  }, [companyData]);

  if (errorGetCompanies)
    return <ErrorMessageContainer message="Couldn't load companies list" />;
  const defaultCompanySubPath = "behavior-kits";
  function handleClick(companyUUID: string, parentCompanyUUID?: string) {
    if (parentCompanyUUID) {
      goToSubCompany(
        parentCompanyUUID ?? "",
        companyUUID ?? "",
        defaultCompanySubPath
      );
    } else {
      goToCompany(companyUUID ?? "", defaultCompanySubPath);
    }
  }

  return (
    <>
      <PageHeader title={"Companies"}>
        <div className="flex">
          <SearchBar placeholder="Search by Company Name"></SearchBar>
          {companies.canAdd && (
            <AddCompanyButton companyType="Company"></AddCompanyButton>
          )}
        </div>
      </PageHeader>
      <div>
        <Table
          isLoading={loadingCompanies}
          header={tableHeader}
          data={companyData?.items ?? []}
          onClick={handleClick}
        />
      </div>
      <Pagination
        pageSize={pageSize}
        currentPage={page}
        totalCount={total}
        search={searchCompanyName}
      />
    </>
  );
};

export default Companies;
